module.exports = __webpack_public_path__ + "img/logo_extracadabra_full_secondary.d77eedce.svg";